import { render, staticRenderFns } from "./ConfigurationList.vue?vue&type=template&id=40e8b851&"
import script from "./ConfigurationList.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports